import { useCallback, useContext } from 'react';
import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { openModalEvent } from '@nx-frontend/shared/ui/modal';
import { PopupType } from '@nx-frontend/shared/types';
import { trackTrialStartPopupSelectPlan } from './analytics';
import { PaywallContext } from './paywall-context';
import { PaywallGradientFooterLine } from './paywall-gradient-footer-line';
import { startFreeTrialEvent } from './store';

export const PaywallFreeTrial = () => {
  const { mode, onClose } = useContext(PaywallContext);
  const [startFreeTrial, openModal] = useUnit([startFreeTrialEvent, openModalEvent]);
  const t = useTranslations('features');
  const onFreePlanClick = useCallback(() => {
    if (mode === 'trialStart') {
      trackTrialStartPopupSelectPlan('free');
      startFreeTrial();
      setTimeout(() => {
        openModal({
          content: PopupType.TRIAL_WELCOME,
          showCloseButton: false,
          payload: {
            payloadType: PopupType.TRIAL_WELCOME,
          },
        });
      }, 250);
      onClose();
    }
  }, [mode, startFreeTrial, onClose, openModal]);
  return (
    <>
      <PaywallGradientFooterLine />
      <div className="paywall__test-drive-with-free flex items-center justify-center pt-6">
        <div className="flex gap-2 text-base items-center text-neutral-800">
          <div>
            {t.rich('paywall.or_test_drive', {
              decorated: (chunk) => (
                <span className="font-semibold cursor-pointer underline" onClick={onFreePlanClick}>
                  {chunk}
                </span>
              ),
            })}
          </div>
          <Button
            type={ButtonType.STROKED}
            size={ButtonSize.CUSTOM}
            onClick={onFreePlanClick}
            className="!px-4 h-[30px] !text-[13px] !rounded duration-200"
          >
            {t('paywall.continue_with_free_plan')}
          </Button>
        </div>
      </div>
    </>
  );
};
